import { onMounted } from 'vue'

import { useReCaptcha } from 'vue-recaptcha-v3'

interface RecaptchaUtils {
  getToken: (action: string) => Promise<string>
  showBadge: () => Promise<void>
  hideBadge: () => Promise<void>
}

const isLocalEnvironment = (): boolean => {
  const hostname: string = window?.location?.hostname || ''

  return !hostname.endsWith('.soluti.com.br')
}

export function useOeRecaptcha(): RecaptchaUtils {
  const recaptcha = useReCaptcha()

  if (!recaptcha) {
    return {
      getToken: async () => '',
      showBadge: async () => void 0,
      hideBadge: async () => void 0,
    }
  }

  const ensureLoaded = async () => {
    try {
      await recaptcha.recaptchaLoaded()
    } catch {
      // Prevent errors if reCAPTCHA fails to load
    }
  }

  onMounted(ensureLoaded)

  const getToken = async (action: string): Promise<string> => {
    if (isLocalEnvironment()) {
      return ''
    }

    if (!recaptcha.executeRecaptcha) {
      return ''
    }

    try {
      return await recaptcha.executeRecaptcha(action)
    } catch (error) {
      return ''
    }
  }

  const showBadge = async () => {
    await ensureLoaded()
    recaptcha.instance?.value?.showBadge?.()
  }

  const hideBadge = async () => {
    await ensureLoaded()
    recaptcha.instance?.value?.hideBadge?.()
  }

  return {
    getToken,
    showBadge,
    hideBadge,
  }
}
